import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import FallbackComponent from "./FallbackComponent"

const ManageClientOrders = lazy(() => import("../pages/client/ManageClientOrders"));
const ClientProfileSettings = lazy(() => import("../pages/client/profile-settings"));
const ClientAccountSettings = lazy(() => import("../pages/client/account-settings"));
const ClientExpertSearch = lazy(() => import("../pages/client/search/expert"));
const ClientTransactions = lazy(() => import("../pages/client/payment-transactions"));
const ClientDisputeResolution = lazy(() => import("../pages/client/dispute-resolution"));
const CreateNewTask = lazy(() => import("../pages/common/post-a-task"));

const ClientPath = () => {
    return (
        <Routes>
            <Route path="*" element={<Navigate replace to={`/client/orders`} />} />
            <Route path="orders" element={<Suspense fallback={<FallbackComponent />}><ManageClientOrders /></Suspense>} />
            <Route path="create-new-task" element={<Suspense fallback={<FallbackComponent />}><CreateNewTask /></Suspense>} />
            <Route path="transactions" element={<Suspense fallback={<FallbackComponent />}><ClientTransactions /></Suspense>} />
            <Route path="profile-settings" element={<Suspense fallback={<FallbackComponent />}><ClientProfileSettings /></Suspense>} />
            <Route path="account-settings" element={<Suspense fallback={<FallbackComponent />}><ClientAccountSettings /></Suspense>} />
            <Route path="search" element={<Suspense fallback={<FallbackComponent />}><ClientExpertSearch /></Suspense>} />
            <Route path="dispute-resolution" element={<Suspense fallback={<FallbackComponent />}><ClientDisputeResolution /></Suspense>} />
        </Routes>
    );
}

export default ClientPath;
